// extracted by mini-css-extract-plugin
export default {"overlay":"GlobalSearch_overlay__Yqx6M","closebtn":"GlobalSearch_closebtn__6Vq1O","searchContainer":"GlobalSearch_searchContainer__VQckY"};